module.exports = __webpack_public_path__ + "static/media/empty_report.ce80ae90.svg";